import { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { DoorIntro } from './brand/DoorIntro';
import { RequireAuth, takeDoor } from './lib/auth';
import { AdminLayout } from './pages/admin/AdminLayout';
import { Overview } from './pages/admin/Overview';
import { ProposalDetail } from './pages/admin/ProposalDetail';
import { ProposalList } from './pages/admin/ProposalList';
import { ProposalNew } from './pages/admin/ProposalNew';
import { ClientHome } from './pages/ClientHome';
import { Login } from './pages/Login';
import { Viewer } from './pages/Viewer';

export const App = () => {
  const location = useLocation();
  const [door, setDoor] = useState(false);
  const doorDone = useCallback(() => setDoor(false), []);

  // signing in arms the door; it opens over whatever screen comes next
  useEffect(() => {
    if (takeDoor()) setDoor(true);
  }, [location.pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/propostas" element={<RequireAuth>{(me) => <ClientHome email={me.email} />}</RequireAuth>} />
        <Route path="/p/:slug" element={<RequireAuth>{() => <Viewer />}</RequireAuth>} />
        <Route path="/admin" element={<RequireAuth admin>{(me) => <AdminLayout email={me.email} />}</RequireAuth>}>
          <Route index element={<Overview />} />
          <Route path="propostas" element={<ProposalList />} />
          <Route path="propostas/nova" element={<ProposalNew />} />
          <Route path="propostas/:id" element={<ProposalDetail />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {door && <DoorIntro onDone={doorDone} />}
    </>
  );
};
